import './promise-polyfill'
import { app } from './app'

// Enable progressive web app support (with offline-plugin)
if (process.env.NODE_ENV === 'production') {
  // PWA not jet implemented. But will be a good use case to cache images
  // remember to add it in webpack.prod.js
  // require('./pwa')
}

app.$mount('#wsc_shop_app')



// WEBPACK FOOTER //
// ./client/index.js